import {ReactComponent as ChatbotIcon} from '../../../icons/chatbot/chatbot_icon.svg'
import {AnalyticsHandler} from '../../../shared/handlers/analytics/handlers.js'
import {
  StyledChatbotCTA,
  StyledChatbotCTAIcon,
  StyledChatbotCTATitle,
  StyledChatbotCTADescription,
  StyledChatbotCTAButton,
  StyledSparkleIcon
} from './ChatbotCTAStyles'

const ChatbotCTA = () => {
  const handleChatbotButtonClick = () => {
    const chatbotEvent = new CustomEvent('openChatbot', {
      detail: {source: 'persona-cta'}
    })
    globalThis.dispatchEvent(chatbotEvent)

    AnalyticsHandler.onChatbotButtonClick({button: {name: 'Persona CTA'}})
  }

  return (
    <StyledChatbotCTA>
      <StyledChatbotCTAIcon>
        <ChatbotIcon />
      </StyledChatbotCTAIcon>
      <StyledChatbotCTATitle>Explore Persona Data Instantly with AI Agent</StyledChatbotCTATitle>
      <StyledChatbotCTADescription>
        Healthprism Agent helps you gain tailored insights for smarter communication.
      </StyledChatbotCTADescription>
      <StyledChatbotCTAButton onClick={handleChatbotButtonClick}>
        <StyledSparkleIcon /> Explore Now
      </StyledChatbotCTAButton>
    </StyledChatbotCTA>
  )
}

export default ChatbotCTA
